var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.04614C0.5 5.13208 1.23828 4.35864 2.1875 4.35864C3.10156 4.35864 3.875 5.13208 3.875 6.04614V8.85864H2.1875H1.625C0.992188 8.85864 0.5 8.36646 0.5 7.73364V6.04614ZM4.4375 4.35864H14C15.8633 4.35864 17.375 5.87036 17.375 7.73364V14.4836H11.5391C10.4141 14.4836 9.5 15.4329 9.5 16.5579V16.7336C9.5 17.9993 8.48047 18.9836 7.25 18.9836C5.98438 18.9836 5 17.9993 5 16.7336V6.04614C5 5.41333 4.78906 4.85083 4.4375 4.35864ZM16.8125 20.1086H13.4375H7.25C9.11328 20.1086 10.625 18.5969 10.625 16.7336V16.5579C10.625 16.0305 11.0469 15.6086 11.5391 15.6086H20.1875C20.4688 15.6086 20.75 15.8899 20.75 16.1711C20.75 18.3508 18.957 20.1086 16.8125 20.1086Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default ForwardRef;